<template>
  <div v-if="isAdmin || checkAccess('staffs')">
    <report-list-page
        page-title="Staff Report"
        page-icon="mdi-account"
        :descending="true"
        :headers="headers"
        state-end-point="staff.staffs"
        :actions="actions"
        :show-component="showComponent"
        item-key="id"
    />
  </div>
</template>

<script>
import ReportListPage from "../../components/ReportListPage";
import IsAuthenticated from "../../middleware/IsAuthenticated";
export default {
  name: "StaffReport",
  mixins: [IsAuthenticated],
  components: {ReportListPage},
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: false
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false
        },
        {
          text: 'Total Order',
          value: 'totalOrder',
          sortable: false
        },
        {
          text: 'Total Link',
          value: 'totalLink',
          sortable: false
        },
      ],
      actions: {
        load: 'loadStaffs',
        downloadPDF: 'downloadStaffAsPDF'
      },
      showComponent: {
        isUser: false,
        isStatus: false,
        isMethod: false,
        isEmail: false,
        isSite: false,
        isPDF: false,
        isDate: true,
        isStaffPDF: true
      }
    }
  }
}
</script>

<style scoped>

</style>